import React, { useState, useRef, useEffect } from "react"
import { Typography, Button, Badge, Input, message, useCRUDController, Row, Col, Card, Select, Divider } from "../../ui/ot"
import { ChartWithdrawn } from "./chart_withdrawn"
import { ChartDamageDiscardRate } from "./chart_damage_discard_rate"
// import { ChartCategoryAdditionTrend } from "./chart_category_addition_trend"
import { ChartDiscardReasonTrend } from "./chart_discard_reason_trend"
import { TableHoldingTotal } from "./table_holding_total"
import { TableWithdrawnDetail } from "./table_withdrawn_detail"
import dayjs from 'dayjs';
import { BadgeInfo, Minus } from 'lucide-react';
import { ChartWithdrawnTrend } from "./chart_withdrawn_trend"

const basicFilterSetting = ["branchcode", 'itemtype']

const HoldingsRemoved = ({
    filterSearchParams = [...basicFilterSetting]

}) => {
    const [searchParams, setSearchParams] = useState({
        item_type: null,
        branchcode: null,
        
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    useEffect(() => {
        libraryController.getData({})
        itemtypeController.getData({})
    }, []);
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <Row align="middle">
                <Col>
                    <Minus className="h-5 w-5" />
                </Col>
                <Col>
                    <Typography.Title level={4}>
                        館藏淘汰量統計
                    </Typography.Title>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Row >
                        {filterSearchParams.includes("branchcode") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    分館篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.branchcode}
                                        value={searchParams?.branchcode}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    branchcode: value
                                                }
                                            })
                                        }}
                                        options={libraryController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.branchcode})${option?.branchname}`,
                                                value: option?.branchcode,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                        {filterSearchParams.includes("itemtype") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    館藏分類篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.itemtype}
                                        value={searchParams?.itemtype}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    item_type: value
                                                }
                                            })
                                        }}
                                        options={itemtypeController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.itemtype})${option?.description}`,
                                                value: option?.itemtype,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                    </Row>
                </Col>
                <Col span={24}>
                    <Row align="middle" gutter={[4, 4]}>
                        <Col>
                            <BadgeInfo size={16} />
                        </Col>
                        <Col>
                            <Typography.P>
                                透過調整館藏分館、館藏分類篩選，呈現館藏此月以及上月淘汰數量還有兩者損壞淘汰率
                            </Typography.P>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
                    <Row gutter={[8, 8]}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            <ChartWithdrawn
                                propsDataParams={{
                                    time: dayjs().format("YYYY-MM-DD"),
                                    branchcode: searchParams?.branchcode,
                                    item_type: searchParams?.item_type
                                }}
                            />
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            <ChartWithdrawn
                                propsDataParams={{
                                    time: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
                                    branchcode: searchParams?.branchcode,
                                    item_type: searchParams?.item_type
                                }}
                                propsLabel={"上月淘汰"}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                    <ChartDamageDiscardRate
                        propsDataParams={{
                            ...searchParams,
                            start_time: dayjs().startOf("month").subtract(1, "month").format("YYYY-MM-DD"),
                            end_time: dayjs().endOf("month").format("YYYY-MM-DD")
                        }}
                    />
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"月度淘汰趨勢"}
                        extra={"淘汰館藏數量長條圖"}
                    >
                        <ChartWithdrawnTrend />
                    </Card>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"淘汰原因趨勢"}
                        extra={"不同淘汰原因的淘汰數量趨勢"}
                    >
                        <ChartDiscardReasonTrend />
                    </Card>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Card title={"淘汰館藏詳細資料"} >
                <TableWithdrawnDetail />
            </Card>
        </Col>

    </Row>)
}
export { HoldingsRemoved }